import React from "react";
import {
  vstStore,
  bookshelf,
  vstAnalytics,
  readOffline,
  brandSpecificApps
} from "../../menu-items/apps";
import Icon, { PlaceHolder } from "../icons";
import { IconList as Wrapper, IconListItem, IconTitle } from "../styles";

const IconList = ({ iconWidth = 44, iconHeight = 44, imgStyle = {} }) => {
  const elements = [bookshelf(), readOffline(), vstStore(), vstAnalytics()]
    .concat(brandSpecificApps())
    .filter(el => !!el);

  const placeholders = [];
  var i = elements.length % 3;
  for (i; i > 0 && i < 3; i++) {
    placeholders.push(
      <IconListItem key={`placeholder-${i}`}>
        <PlaceHolder />
      </IconListItem>
    );
  }

  return (
    <Wrapper>
      {elements.map(
        (
          { customIcon, fill, icon, iconLetter, onClick, text: label },
          index
        ) => (
          <IconListItem key={`${label}-${index}}`}>
            <a href="#" onClick={onClick}>
              <Icon
                customIcon={customIcon}
                fill={fill}
                icon={icon}
                letter={iconLetter}
                width={iconWidth}
                height={iconHeight}
                imgStyle={imgStyle}
              />
              <IconTitle className="iconTitle">{label}</IconTitle>
            </a>
          </IconListItem>
        )
      )}
      {placeholders}
    </Wrapper>
  );
};

export default IconList;
